export enum TransferMode {
    Queue = 'queue',
    Attendant = 'attendant',
}
